export const environment = {
  orgId: 'cle',
  production: true,
  apiURL: "https://www.clemarketaccess.com"
};
